var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSupIconInactive = function SvgSupIconInactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#697477",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25,
    d: "m8.958 8.542-5.416 5.416a1.768 1.768 0 0 0 2.5 2.5l5.416-5.416"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#697477",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25,
    d: "m8.958 8.542 2.5 2.5.678-.14c.861-.178 1.668.479 1.668 1.358.256.256.384.384.524.447a.83.83 0 0 0 .68 0c.14-.063.269-.191.525-.447l1.728-1.73c.257-.258.386-.387.448-.528a.83.83 0 0 0 0-.675c-.062-.142-.191-.27-.448-.528h-.864c-.183-.183-.385-.358-.537-.568-.52-.72-.13-1.588-.545-2.335-.054-.098-.101-.16-.194-.287-2.085-2.824-4.873-3.761-8.294-3.129a.455.455 0 0 0-.369.45c0 .169.092.323.237.41C8.792 4.587 9.41 6.017 8.958 8.541"
  })));
};
export { SvgSupIconInactive as ReactComponent };
export default __webpack_public_path__ + "b434e2b95205274db0eee0c62a3b4aae.svg";